import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { reportToHeimdall } from '@vendasta/core';
import { AppModule } from './app/app.module';
import { devServer } from './globals';

if (!devServer) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => {
    reportToHeimdall(err);
    console.error(err);
  });
